import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { PortfolioContentOne } from "./projectOne/PortfolioContentOne";

export const PortfolioTextQA = () => {
  return (
    <div>
      <NavBar />
      <PortfolioContentOne />
      <Footer />
    </div>
  );
};
